/**
 * Color constants for consistent UI theming across the application.
 * These values mirror the backend ChartColors constants.
 */

export const CHART_COLORS = {
  PRIMARY_GREEN: "#3CC858",
  SECONDARY_GREEN: "#258B3A", 
  TERTIARY_GREEN: "#1B662A",
  PRIMARY_BLUE: "#52A8FF",
} as const;

export const STATUS_COLORS = {
  SUCCESS: CHART_COLORS.PRIMARY_GREEN,
  WARNING: "#FF872B",
  ERROR: "#FF0000",
  PENDING: "#FCD34D", // yellow-400
} as const;

export const SECURITY_COLORS = {
  SECURE: CHART_COLORS.PRIMARY_GREEN,
  MODERATE: STATUS_COLORS.WARNING,
  CRITICAL: STATUS_COLORS.ERROR,
} as const; 